import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=1e44f09e&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=ts&"
export * from "./Index.vue?vue&type=script&lang=ts&"
import style0 from "./Index.vue?vue&type=style&index=0&id=1e44f09e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e44f09e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("c:\\vNextBuildV3\\29\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1e44f09e', component.options)
    } else {
      api.reload('1e44f09e', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=1e44f09e&scoped=true&", function () {
      api.rerender('1e44f09e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "VueApp/views/Welcome/Index.vue"
export default component.exports